// extracted by mini-css-extract-plugin
module.exports = {"minHeight":"styles_minHeight__1sQ3Z","placeholderAnchor":"styles_placeholderAnchor__3nLW6","placeholder":"styles_placeholder__G2vU4","spaceUnder":"styles_spaceUnder__2xcYN"};